/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2025-05-28 15:04:59
 */
import App from "./App.vue";
import router from "./router";
import { antComponents } from "./antd";
import { CommonComponents } from "./use-common-components";
import "virtual:svg-icons-register";
import store, { storeKey } from "./store";
import { createInstance } from "/@/root";
import "/@/styles/index.scss";
// import 'ant-design-vue/dist/reset.css';
import directives from "./utils/drag";
import { message } from "ant-design-vue";
import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css
import VueCesium from "vue-cesium";
import "/@/assets/iconfont/iconfont.css";
const app = createInstance(App);
app.use(store, storeKey);
app.use(VueCesium);
app.use(vue3videoPlay);
message.config({
  duration: 1, // 持续时间
  top: "45%", // 到页面顶部距离
});

app.use(directives);
app.use(router);
app.use(CommonComponents);
app.use(antComponents);
app.mount("#demo-app");
